import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appFirstLetters]',
})
export class FirstLettersDirective implements OnChanges {
  @Input() public isExpanded = true;
  @Input() public text = '';
  @Input() public maxLetters = 4;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['isExpanded'] || changes['text']) {
      this.updateText();
    }
  }

  private updateText(): void {
    const displayText = this.isExpanded
      ? this.text
      : this.text
          ?.match(/\b(\w)/g)
          ?.slice(0, this.maxLetters)
          .join('') || '';

    this.renderer.setProperty(this.elementRef.nativeElement, 'textContent', displayText);
  }
}
